// FLATTEN the wire Metric shape into the card view the components consume — shared by the KPIs board and
// the Today KPI strip (both read the ONE `MetricStateWire` shape the server sends). The server nests the
// Metric under `metric`, the recorded series under `authoritativeHistory`, and the composed linked Tasks
// (titles via the tasks port — a raw id never renders, G-197) under `linkedTasks`. BUILD-DEC-093.

import type {
  MetricCard,
  MetricsBoardProjection,
  MetricsBoardWire,
  MetricStateWire,
} from '../projections.ts';

/** Flatten one wire `MetricStateView` into the component card shape. */
export function flattenCard(wire: MetricStateWire): MetricCard {
  const value = wire.latestAuthoritativeValue;
  const cadenceKind = wire.metric.cadence['kind'];
  return {
    id: wire.metric.id,
    name: wire.metric.name,
    state: wire.metric.state,
    definition: wire.metric.definition.statement,
    clarificationQuestions: wire.metric.definition.clarificationQuestions ?? [],
    latestValue:
      value === null
        ? null
        : {
            id: value.id,
            value: value.value,
            state: value.state,
            periodStart: value.period.start,
            periodEnd: value.period.end,
          },
    series: wire.authoritativeHistory.map((point) => ({
      periodStart: point.period.start,
      periodEnd: point.period.end,
      value: point.value,
    })),
    target: wire.metric.safeParameters.target,
    cadenceLabel: typeof cadenceKind === 'string' ? cadenceKind : null,
    trendDirection: wire.trendDirection,
    recentTrendDirection: wire.recentTrendDirection,
    activationReadiness: wire.activationReadiness,
    linkedTasks: wire.linkedTasks.map((task) => ({
      id: task.id,
      title: task.title,
      brief: task.brief,
      state: task.state,
      updatedAt: task.updatedAt,
    })),
  };
}

/** Flatten the whole wire board once so the grid + detail consume one shape. */
export function flattenBoard(wire: MetricsBoardWire): MetricsBoardProjection {
  return { metrics: wire.metrics.map(flattenCard) };
}
